import React, { useState } from 'react'
import { useSpring, animated as a } from 'react-spring'
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col
} from "reactstrap";
// core components
import SimpleHeader from "../../../../components/Headers/SimpleHeader";
import './styles.css';

function Card1() {
  const [flipped, set] = useState(false);
  const total = 40;
  const { transform, opacity } = useSpring({
    opacity: flipped ? 1 : 0,
    transform: `perspective(600px) rotateX(${flipped ? 180 : 0}deg)`,
    config: { mass: 5, tension: 500, friction: 80 }

  })
  return (
    <div onClick={() => {
      var i = Math.floor(Math.random()*total);
      var url = "url(https://s3-ap-southeast-2.amazonaws.com/games-ccl/CCL-IMAGE/" + i +".png)";
      document.getElementById('back1').style.backgroundImage = url;
      document.getElementById('front1').style.backgroundImage = url;
      // document.getElementsByClassName('front').style.backgroundImage = url;
      set(state => !state)
      }}>
      <a.div class="c" id="back1" style={{ opacity: opacity.interpolate(o => 1 - o), transform }} />
      <a.div class="c" id="front1" style={{ opacity, transform: transform.interpolate(t => `${t} rotateX(180deg)`) }} />
    </div>
  )
}

function Card2() {
  const [flipped, set] = useState(false);
  const total = 40;
  const { transform, opacity } = useSpring({
    opacity: flipped ? 1 : 0,
    transform: `perspective(600px) rotateX(${flipped ? 180 : 0}deg)`,
    config: { mass: 5, tension: 500, friction: 80 }

  })
  return (
    <div onClick={() => {
      var i = Math.floor(Math.random()*total);
      var url = "url(https://s3-ap-southeast-2.amazonaws.com/games-ccl/CCL-IMAGE/" + i +".png)";
      document.getElementById('back2').style.backgroundImage = url;
      document.getElementById('front2').style.backgroundImage = url;
      // document.getElementsByClassName('front').style.backgroundImage = url;
      set(state => !state)
      }}>
      <a.div class="c" id="back2" style={{ opacity: opacity.interpolate(o => 1 - o), transform }} />
      <a.div class="c" id="front2" style={{ opacity, transform: transform.interpolate(t => `${t} rotateX(180deg)`) }} />
    </div>
  )
}

function Card3() {
  const [flipped, set] = useState(false);
  const total = 40;
  const { transform, opacity } = useSpring({
    opacity: flipped ? 1 : 0,
    transform: `perspective(600px) rotateX(${flipped ? 180 : 0}deg)`,
    config: { mass: 5, tension: 500, friction: 80 }

  })
  return (
    <div onClick={() => {
      var i = Math.floor(Math.random()*total);
      var url = "url(https://s3-ap-southeast-2.amazonaws.com/games-ccl/CCL-IMAGE/" + i +".png)";
      document.getElementById('back3').style.backgroundImage = url;
      document.getElementById('front3').style.backgroundImage = url;
      // document.getElementsByClassName('front').style.backgroundImage = url;
      set(state => !state)
      }}>
      <a.div class="c" id="back3" style={{ opacity: opacity.interpolate(o => 1 - o), transform }} />
      <a.div class="c" id="front3" style={{ opacity, transform: transform.interpolate(t => `${t} rotateX(180deg)`) }} />
    </div>
  )
}
function Card4() {
  const [flipped, set] = useState(false);
  const total = 40;
  const { transform, opacity } = useSpring({
    opacity: flipped ? 1 : 0,
    transform: `perspective(600px) rotateX(${flipped ? 180 : 0}deg)`,
    config: { mass: 5, tension: 500, friction: 80 }

  })
  return (
    <div onClick={() => {
      var i = Math.floor(Math.random()*total);
      var url = "url(https://s3-ap-southeast-2.amazonaws.com/games-ccl/CCL-IMAGE/" + i +".png)";
      document.getElementById('back4').style.backgroundImage = url;
      document.getElementById('front4').style.backgroundImage = url;
      // document.getElementsByClassName('front').style.backgroundImage = url;
      set(state => !state)
      }}>
      <a.div class="c" id="back4" style={{ opacity: opacity.interpolate(o => 1 - o), transform }} />
      <a.div class="c" id="front4" style={{ opacity, transform: transform.interpolate(t => `${t} rotateX(180deg)`) }} />
    </div>
  )
}

class FlipCard extends React.Component {
  render() {
    return (
      <>
        <SimpleHeader name="Flip Card" parentName="Games" />
        <Container className="mt--6" fluid>
          <Card className="mb-4">
            <CardHeader>
              <h3 className="mb-0">Form group in grid</h3>
            </CardHeader>
            <CardBody className="flipcard-body">
              <Row>
                <Col md={6}>
                  <div class="card-container">
                    <Card1 />
                  </div>
                </Col>
                <Col md={6}>
                  <div class="card-container">
                    <Card2 />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <div class="card-container">
                    <Card3 />
                  </div>
                </Col>
                <Col md={6}>
                  <div class="card-container">
                    <Card4 />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </>
    );
  }
}
export default FlipCard;
